import styled from 'styled-components';

const Section = styled.section<{
  showBorder?: boolean;
}>`
  border: ${({ showBorder }) =>
    showBorder ? '0.0625rem solid #ebebeb' : 'none'};
  border-radius: 0.5rem;

  header {
    background-color: #ebebeb;
    border-radius: 0.5rem 0.5rem 0 0;
    padding: 0.5rem;

    h3,
    h4 {
      line-height: 1;
      margin: 0;
    }
  }

  main {
    background-color: #fff;
    border-radius: 0 0 0.5rem 0.5rem;
    padding: 0.5rem;
    margin-left: 0;
  }
`;

export default Section;
